export default __webpack_public_path__ + "static/media/t-arrow.34fe8f99.svg";